export default __webpack_public_path__ + "static/media/iconfinder_user.6520ab81.png";